import React from "react";
import { BOND_PRINCIPAL_KIND } from "../../shared/hooks/useBondPrincipalForm";
import BondPrincipalScreen from "../../shared/components/BondPrincipalScreen";
import { BOND_PRINCIPAL_SHELL_VA_TRUSTEE } from "../../shared/bondWizardStepPropTypes";

const Principals = ({ data, updateData, globalData, isGuest }) => (
  <BondPrincipalScreen
    kind={BOND_PRINCIPAL_KIND.va}
    data={data}
    updateData={updateData}
    globalData={globalData}
    isGuest={isGuest}
  />
);

Principals.propTypes = BOND_PRINCIPAL_SHELL_VA_TRUSTEE;

export default Principals;
